import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import FormatUtils from '../common/formatUtils/FormatUtils';
import consts from '../consts';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import ClipboardImageHandler from './ClipboardImageHandler';

import {
	initFormHistorico
} from './pedidoActions';

class PedidoHistoricoForm extends Component {

	state = {

	}

	componentWillMount() {

		let initSeletorArquivo = () => {
			const fileSelectorArquivo = document.createElement('input');
			fileSelectorArquivo.setAttribute('type', 'file');
			fileSelectorArquivo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')
						&& !file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
						&& !file.type.includes('application/vnd.ms-excel')
						&& !file.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
						&& !file.type.includes('application/msword')) {
						setError('Selecione apenas (.PDF, .XLSX, .XLS, .DOC, .DOCX, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.anexos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initFormHistorico({
							...this.props.formularioValues,
							anexos: lista
						});

						initSeletorArquivo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorArquivo = fileSelectorArquivo;
		};

		initSeletorArquivo();

    }
	
    render() {

		let readOnly = this.props.formularioValues.excluir ? 'readOnly' : '';

		return (
			<div>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							
							<Field
								name='descricao'
								component={LabelAndTextarea}
								label='Descrição' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly}
								rows={6}/>

						</Row>

						<Row style={{ paddingBottom: 16 }}>
							<Grid cols='12 12 12 12'>
								<label>Anexos</label>
							</Grid>
							
								{(this.props.formularioValues.anexos || []).map(arquivo => (
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-primary'
												style={{ width: '48%' }}
												disabled={arquivo.arquivo_base64 ? true : false}
												onClick={() => {
													window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
												}}>
												<i class='fas fa-download'></i>
											</button>
											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ width: '48%' }}
												disabled={readOnly}
												onClick={() => {
													this.props.initFormHistorico({
														...this.props.formularioValues,
														anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>
								))}
								{/*!readOnly ? (
									<span class="btn btn-outline-primary fileinput-button dz-clickable" onClick={() => this.fileSelectorArquivo.click()}>
										<img src={pdfAdd} style={{ height: 30 }} />
									</span>
								) : null*/}
							
						</Row>

						{!readOnly &&
						<ClipboardImageHandler
							label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
							msgErro='Selecione apenas (.PDF, .XLSX, .XLS, .DOC, .DOCX, .PNG, .JPG e .JPEG)'
							types={[
								'application/pdf',
								'image/png',
								'image/jpg',
								'image/jpeg',
								'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
								'application/vnd.ms-excel',
								'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
								'application/msword'
							]}
							onChange={result => {
								let lista = (this.props.formularioValues.anexos || []).map(item => item);
								lista.push({
									arquivo_base64: result
								});

								this.props.initFormHistorico({
									...this.props.formularioValues,
									anexos: lista
								});
							}} />}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.formularioValues.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'secondary'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Cancelar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.initFormHistorico(null)} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</div>
		);
    }


}

PedidoHistoricoForm = reduxForm({form: 'pedidoHistoricoForm', destroyOnUnmount: false})(PedidoHistoricoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('pedidoHistoricoForm')(state),
	registro: state.pedido.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	initFormHistorico
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoHistoricoForm);
